export default "__VITE_ASSET__COO$H_Ru__"